import { useSelector, TypedUseSelectorHook } from 'react-redux';
import { SliceStates } from '../store/sliceTypes';

export const useTypedSelector: TypedUseSelectorHook<SliceStates> = useSelector;